import React from "react";
import { Skeleton } from "antd";
import * as R from "ramda";

import styled, { css } from "styled-components/macro";

const SkeletonItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  animation: fadeIn 0.5s ease;
  width: 100%;

  .ant-skeleton {
    width: auto;
  }

  .skeleton-name {
    margin-top: 15px;
    margin-left: 10px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const CardsSkeleton = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  .skeleton-avatar .ant-skeleton-title {
    height: 48px;
    border-radius: 24px;
    margin: 16px 12px;
  }

  ${({ showGrid }) =>
    showGrid
      ? css`
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
          grid-gap: 16px;
          margin: 0;
          -webkit-mask-image: -webkit-gradient(
            linear,
            left 60%,
            left bottom,
            from(rgba(0, 0, 0, 1)),
            to(rgba(0, 0, 0, 0))
          );
        `
      : css`
          ${SkeletonCard} {
            margin-bottom: 25px;
          }
        `}
`;

const SkeletonCard = styled.article`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  transition: 0.3s ease;
  overflow: hidden;
  background: white;
  width: 100%;

  .skeleton-text {
    margin-left: 82px;
    margin-top: 0px;

    .ant-skeleton-title {
      margin-top: -10px;
      margin-bottom: 20px;
    }
  }
`;

export const CardSkeleton = ({ compact }) => {
  return (
    <SkeletonCard>
      <SkeletonItem>
        <Skeleton
          className="skeleton-avatar"
          active
          avatar={false}
          title={{ width: 48, rows: 1 }}
          paragraph={false}
        />
        <Skeleton
          active
          className="skeleton-name"
          avatar={false}
          title={{ width: 110, rows: 1 }}
          paragraph={false}
        />
      </SkeletonItem>
      {!compact && (
        <>
          <Skeleton
            active
            className="skeleton-text"
            avatar={false}
            title={{ width: 100, rows: 1 }}
            paragraph={false}
          />

          <Skeleton
            active
            className="skeleton-text"
            avatar={false}
            title={{ width: 75, rows: 1 }}
            paragraph={false}
          />
          <Skeleton
            active
            className="skeleton-text"
            avatar={false}
            title={{ width: 60, rows: 1 }}
            paragraph={false}
          />
        </>
      )}
    </SkeletonCard>
  );
};

export const SkeletonCandidates = ({ showGrid = false, cardsNumber = 3 }) => {
  return (
    <CardsSkeleton showGrid={showGrid}>
      {R.times(
        i => (
          <CardSkeleton key={i} />
        ),
        cardsNumber
      )}
    </CardsSkeleton>
  );
};

export const SkeletonCandidatesCompact = ({
  showGrid = false,
  cardsNumber = 3
}) => {
  return (
    <CardsSkeleton showGrid={showGrid}>
      {R.times(
        i => (
          <CardSkeleton key={i} compact />
        ),
        cardsNumber
      )}
    </CardsSkeleton>
  );
};

export default SkeletonCandidates;
